import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { userCan } from '../../../helpers/Auth';
import { getCurrentURLParams } from '../../../helpers/URLParams';
import { getBackButtonMeta } from '../../../helpers/App';

import EmptyTableCell from '../../EmptyTableCell';

const AdminRolesListItem = ({
  role,
  handleDelete,
  location,
}) => {
  const intl = useIntl();

  const linkTo = {
    pathname: `/admin/settings/roles/${role.id}/edit`,
    state: {
      goBackToListButton: {
        ...getBackButtonMeta('roles'),
        search: getCurrentURLParams(location),
      },
    },
  };

  return (
    <tr>
      <th scope="row" className="role-name">
        <div className="user-avatar role-avatar">
          <div className="avatar avatar-40 icon-avatar gray">
            <i className="fas fa-user-lock" />
          </div>
        </div>
        {userCan('edit_role', role) ? (
          <Link to={linkTo}>
            {role.name}
          </Link>
        ) : (
          <span>{role.name}</span>
        )}
      </th>
      <td className="role-description">
        {role.description && role.description.length > 0 ? role.description : <EmptyTableCell />}
      </td>
      <td className="role-users">
        {role.users.length}
      </td>
      <td className="action-more">
        {userCan('edit_role', role) && (
          <UncontrolledDropdown>
            <DropdownToggle nav className="options">
              <i className="far fa-ellipsis-h" />
            </DropdownToggle>
            <DropdownMenu right>
              <Link to={linkTo} className="dropdown-item-link">
                <DropdownItem tag="span">
                  <i className="fas fa-pencil" />
                  {intl.formatMessage({ defaultMessage: 'Edit' })}
                </DropdownItem>
              </Link>
              <DropdownItem divider />
              <DropdownItem onClick={() => { handleDelete(role); }}>
                <i className="fas fa-trash" />
                {intl.formatMessage({ defaultMessage: 'Delete' })}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        )}
      </td>
    </tr>
  );
};

AdminRolesListItem.propTypes = {
  role: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(AdminRolesListItem);
